import { getUserData } from '@/api/commonApi.js'
import VueCookies from 'vue-cookies'
import router from './../../router'
import event from './flydata_event'

var flyata_timer = null;

// var action={
//     'www.akadm.com':"www.akadm.com",
//     'eleeda.akadm.com':'eleeda.akadm.com',
//     'hxz.huayingtek.com':'hxz.huayingtek.com',
//     "yuemi.akadm.com":"yuemi.akadm.com",
// }
console.log(env_config.flydata_url);
console.log(env_config.flydadta_key);
//flydata初始化
function flydataInit(to) {
    console.log(process.env);
    try {
        if(window.location.pathname.indexOf('sso-register')>'-1' && !to.query.token){
            console.log('第三方注册')
            return;
        }
        if (to) {
            if (to.name == "logout") {
                clearInterval(flyata_timer);
                console.log("退出");
                return;
            }
            if (to.name == "jpLogin" || to.name == "login" || to.name == "electronLogin" || to.name == "index" || to.name == "student-index" || to.name == "error"|| to.name == "wwxAuthSuccess") {
                console.log("dis flydata route connect");
                return;
            }
            if (to.name == 'personal-center' || to.name == "topic-static-learning-analysis") {
                VueCookies.remove("class_id");
            }
        }
        clearInterval(flyata_timer)
        // console.log(router);
        let data = {
            class_id: VueCookies.get("class_id") ? VueCookies.get("class_id") : null,
            course_id: router.history.current.query.course_id
        }
        getUserData(data)
            .then(res => {
                console.log(res);
                if (res.errCode == 0) {
                    $("#app").attr("user_type", res.data.user_type_id);
                    if ($("#app").attr("user_type") != res.data.user_type_id) {
                        console.log("用户身份不相等");
                        clearInterval(flyata_timer);
                        return;
                    }
                    if ($("#app").attr("user_type") == 1) {
                        localStorage.setItem("flydata_data_teacher", JSON.stringify(res.data));
                        localStorage.setItem("flydata_data_teacher_type", res.data.app_user_type_id);
                    } else if ($("#app").attr("user_type") == 2) {
                        localStorage.setItem("flydata_data_student", JSON.stringify(res.data));
                    } else {
                        console.log("没有这种类型");
                    }
                    if (res.data.function_status) {
                        if (window.flyIo) {
                            flydataTiming();
                            flydataIdentifyCache(1);
                        } else {
                            flydataSdk();
                        }
                    } else {
                        clearInterval(flyata_timer);
                        console.log("后台开关已关");
                    }
                } else {
                    console.log(res.msg);
                }
            })
            .catch(err => {
                console.log("获取flydta 数据 错误");
            });
    } catch (error) {
        console.log(error)
    }
}

//flydata 存储identify数据
function flydataIdentifyCache(type, flydata_key) {  //type : 1 获取数据 不 初始化   2： 获取数据 并 初始化
    let flydata_json = null;
    if ($("#app").attr("user_type") == 1) {
        flydata_json = JSON.parse(localStorage.getItem("flydata_data_teacher"));
    } else if ($("#app").attr("user_type") == 2) {
        flydata_json = JSON.parse(localStorage.getItem("flydata_data_student"));
    } else {
        console.log("没有这种类型缓存");
    }
    if (type == 2) {
        window.flyIo.load(flydata_key, flydata_json.time);
    }
    // let flydata_json = JSON.parse(localStorage.getItem("flydata_data"));
    let getDeviceInfo = {};
    try {
        if (IMAppObj) {
            if (IMAppObj.getDeviceInfo) {
                console.log("上传版本信息：" + IMAppObj.getDeviceInfo())
                getDeviceInfo = JSON.parse(IMAppObj.getDeviceInfo());
            }
        }
    } catch (error) {
        console.log(error);
    }
    let merge_obj = Object.assign({}, flydata_json.data, getDeviceInfo);
    console.log(merge_obj);
    window.flyIo.identify(flydata_json.data["用户ID"], flydata_json.user_type_id, merge_obj);
}

//flydata 加载sdk
function flydataSdk() {
    try {
        var domain = document.domain;
        // var flydata_key_config = {
        //     test: "2de5aea9da6f0b384e140293a02453d5e327a44b",  //测试IDK
        //     production: "6457361935f40eb9c4f970704c05c75915eb14b4"   //线上IDK

        // };
        var flydata_key = ""; //flydata_key
        var flydata_url = "";
        flydata_key = env_config.flydadta_key;
        flydata_url = env_config.flydata_url;
        window.flyIo = window.flyIo || [];
        window.flyIo.cache = [];
        window.flyIo.methods = "load identify track".split(" ");
        window.flyIo.sdk = flydata_url;
        window.flyIo.factory = function (b) {
            return function () {
                var a = Array.prototype.slice.call(arguments);
                a.unshift(b);
                window.flyIo.cache.push(a);
            }
        };
        for (var i = 0; i < window.flyIo.methods.length; i++) {
            var key = window.flyIo.methods[i];
            window.flyIo[key] = window.flyIo.factory(key);
        }
        window.flyIo.load = function (i) {
            console.log("flydata come in");
            if (!document.getElementById("fly-io-js")) {
                var a = document.createElement("script");
                a.type = "text/javascript";
                a.id = "fly-io-js";
                a.async = !0;
                a.src = window.flyIo.sdk;
                a.onerror = function () {
                    window.flyIo.track = function (ename, props, callback) {
                        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
                            callback();
                        } else if (Object.prototype.toString.call(props) === '[object Function]') {
                            props();
                        }
                    };
                    window.flyIo.identify = function (ename, type, props, callback) {
                        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
                            callback();
                        } else if (Object.prototype.toString.call(props) === '[object Function]') {
                            props();
                        }
                    };
                };
                if (a.addEventListener) {
                    a.addEventListener('load', function () {
                        window.flyIo.method.init(i);
                    }, false);
                } else if (a.attachEvent) {
                    a.attachEvent('onreadystatechange', function () {
                        var target = window.event.srcElement;
                        if (target.readyState === 'loaded') {
                            window.flyIo.method.init(i);
                        }
                    });
                }
                var c = document.getElementsByTagName("script")[0];
                c.parentNode.insertBefore(a, c);
            }
        };
        //加载IDK并初始化
        // let flydata_json = JSON.parse(localStorage.getItem("flydata_data"));
        // window.flyIo.load(flydata_key,flydata_json.time);
        // window.flyIo.identify(flydata_json.data["用户ID"],flydata_json.user_type_id,flydata_json.data);
        flydataIdentifyCache(2, flydata_key);
        console.log(window.flyIo);
        //window.flyIo.track("访问首页",{});
        flydataTiming();
    } catch (error) {
        console.log(error);
        console.error("flydata-sdk 加载错误");
    }
}

//flydata定时
function flydataTiming() {
    try {
        clearInterval(flyata_timer);
        flyata_timer = setInterval(function () {
            flydataSubmit();
        }, 5000)
    } catch (error) {
        console.log(error)
    }
}


//flydata提交数据
function flydataSubmit() {
    try {
        if ($("#app").attr("user_type") != VueCookies.get("user_type")) {
            return console.log("用户类型不对");
        }
        if (!window.flyIo) {
            return console.log("flydata 暂无 init");
        }
        if (!localStorage.getItem("flydata_data_teacher") && !localStorage.getItem("flydata_data_student")) {
            flydataInit();
        }
        console.log("提交 flydata 数据中");
        // let track_data = localStorage.getItem("flydata_track_data");
        let track_data = "";
        if ($("#app").attr("user_type") == 1) {
            track_data = localStorage.getItem("flydata_track_data_teacher");
        } else if ($("#app").attr("user_type") == 2) {
            track_data = localStorage.getItem("flydata_track_data_student");
        } else {
            console.log("没有这种类型缓存");
        }
        console.log(track_data);
        if (track_data) {
            let track_data_json = JSON.parse(track_data);
            if (track_data_json.length > 0) {
                for (let value of track_data_json) {
                    console.log("我是提交的事件event_id :" + value.event_id);
                    console.log(event[value.event_id]);
                    // console.log(window.flyIo);
                    let value_data = value.data;
                    value_data["事件名称"] = event[value.event_id];
                    // if(value.user_type == $("#app").attr("user_type")){
                    window.flyIo.track(value.event_id, value_data);
                    // }
                }
            }
            if ($("#app").attr("user_type") == 1) {
                localStorage.setItem("flydata_track_data_teacher", []);
            } else if ($("#app").attr("user_type") == 2) {
                localStorage.setItem("flydata_track_data_student", []);
            } else {
                console.log("没有这种类型缓存");
            }
            //    localStorage.setItem("flydata_track_data",[]);
        } else {
            console.log("暂无提交数据");
        }
    } catch (error) {
        console.log(error)
    }
}

//flydata触发事件
function flydataTrack(count, obj) {
    try {
        if ($("#app").attr("user_type") != VueCookies.get("user_type")) {
            return console.log("用户类型不对");
        }
        if (!count) {
            console.log(count);
            return console.log("event_id 不能为空");
        }
        let obj_change = obj ? obj : {};
        let new_track_data = [];
        //事件触发参数1:事件ID/参数2:数组数据(事件专属数据)/参数3：回调函数
        let track_data_cache = "";
        if ($("#app").attr("user_type") == 1) {
            track_data_cache = localStorage.getItem("flydata_track_data_teacher");
        } else if ($("#app").attr("user_type") == 2) {
            track_data_cache = localStorage.getItem("flydata_track_data_student");
        } else {
            console.log("没有这种类型缓存");
        }
        let xres = window.screen.width * window.devicePixelRatio
        let yres = window.screen.height * window.devicePixelRatio
        let globalObj = {
            '终端': judeIsElectron() ? '云课件' : '浏览器',
            '分辨率': `${xres}-${yres}`
        }
        if (judeIsElectron()) {
            const remote = window.require('electron').remote;
            let sharedObject = remote.getGlobal('sharedObject');
            globalObj = Object.assign(globalObj, sharedObject.system);
        }
        let push_obj = {};
        push_obj.event_id = count;
        push_obj.data = Object.assign(obj_change, globalObj);
        push_obj.user_type = $("#app").attr("user_type");
        if (track_data_cache) {
            new_track_data = JSON.parse(track_data_cache);
            new_track_data.push(push_obj)
        } else {
            new_track_data.push(push_obj)
        }
        if ($("#app").attr("user_type") == 1) {
            localStorage.setItem("flydata_track_data_teacher", JSON.stringify(new_track_data));
        } else if ($("#app").attr("user_type") == 2) {
            localStorage.setItem("flydata_track_data_student", JSON.stringify(new_track_data));
        } else {
            console.log("没有这种类型缓存");
        }
    } catch (error) {
        console.log(error)
    }
}

function judeIsElectron() {
    var userAgent = navigator.userAgent.toLowerCase();
    console.log(userAgent);
    if (userAgent.indexOf(' electron/') > -1) {
        console.log("我是electron环境")
        if (userAgent.indexOf('akadm-desktop') > -1) {
            return true;
        }
    }
    return false;
}

export default {
    flydataInit: flydataInit,       //初始化
    flydataTrack: flydataTrack,     //触发事件
    flydataSubmit: flydataSubmit,   //提交数据
}

